import { Accordion } from '@material-ui/core';
import styled from 'styled-components';

import { px, fontFamilySize } from '../../contrib/ui';

export const AccordionCardStyled = styled(Accordion)`
  box-shadow: ${px(0)} ${px(0)} ${px(5)} ${px(5)} rgb(0 0 0 / 5%);
  border-radius: ${px(4)};
  margin-top: 0;
  margin-bottom: ${px(15)};

  .accordion-summary {
    div {
      flex-direction: row;
      align-items: center;
      margin: ${px(10)} 0;
      h3 {
        position: relative;
        top: 0.08em;
        margin: 0;
        line-height: 1.6;
      }
      .tooltip-fab--shift-top-5 {
        top: 0;
        margin: 0;
        margin-left: ${px(10)};
      }
    }
  }

  .accordion-details {
    flex-direction: column;
    p {
      margin: ${px(5)} 0;
      ${fontFamilySize('Regular', 14)}
    }
  }
`;
